import { render, staticRenderFns } from "./course_open_management.vue?vue&type=template&id=0c75d507&scoped=true&"
import script from "./course_open_management.vue?vue&type=script&lang=js&"
export * from "./course_open_management.vue?vue&type=script&lang=js&"
import style0 from "./course_open_management.vue?vue&type=style&index=0&id=0c75d507&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c75d507",
  null
  
)

export default component.exports